import React from "react";
import book from "../Images/book.jpeg";
import cap from "../Images/cap.jpeg";
import earth from "../Images/earth.jpeg";

const Feature = ({ image, title, desc }) => (
  <div className="text-2xl text-center bg-white p-5 rounded-lg shadow-sm">
    <img src={image} alt={title}  className="mx-auto mb-3 w-14 h-14 object-contain"/>
    <h4 className="font-bold text-lg">{title}</h4>
    <p className="text-sm text-gray-600 mt-2">{desc}</p>
  </div>
);

export default function Features() {
  return (
    <section id="features" className="container-fluid px-4 py-12">
      <div className="text-center mb-8">
        <h2 className="text-xl text-white">Unique Features of our programs</h2>
        <h3 className="text-white text-3xl font-bold">What do want to study?</h3>
      </div>

      <div className="container grid grid-cols-1 md:grid-cols-3 gap-6">
        <Feature
          image={cap}
          title="UG PG Offline Programs"
          desc="Our offline undergraduate and postgraduate programs offer personalized student counselling, direct admission support, and access to reputed colleges across India. We guide students through course selection, documentation, and campus-based learning for a structured and career-focused education experience."
        />

        <Feature
          image={book}
          title="UG PG Online Programs"
          desc="Our Online UG and PG programs are designed for flexibility and convenience without compromising quality. We help students choose recognized universities, complete admissions smoothly, and balance education with work through expert counselling and continuous academic support."
        />

        <Feature
          image={earth}
          title="Study Abroad Programs"
          desc="Our Study Abroad programs provide end-to-end guidance, from student counselling and university selection to admissions and visa assistance. We help students explore global education opportunities, choose the right country and course, and prepare confidently for international academic success."
        />
      </div>
    </section>
  );
}